import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>C Programming</h1>
            <br />
          </div>
          <div className="imgSection">
            <img src={require("../../../images/courses/C.png")} alt="" />
          </div>
          <div className="heading">
            <h4 style={{ color: "blue" }}>Introduction To C Programming</h4>
            <ul>
              <li>
                C Programming is the mother of all Programming languages and is
                a start to building your career in the field of information
                technology. In C Programming class one will learn the usage of
                syntaxes and will learn in details Object Oriented Programming
                OOPS Concepts. Mastery of C language will help you build a solid
                foundation and make learning of any programming language in your
                future endeavors in technology simple. Anyone and everyone can
                learn C Programming Language as it is easy to understand. Post
                learning C language aspiring job-seekers can look to learn more
                technologies coded on C language to further enhance their
                Resume.
              </li>
            </ul>

            <h3 style={{ color: "blue" }}>C Language Syllabus</h3>
            
            <h4>
            Introduction to Programming
            </h4>
            <ul>
              <li>Fundamentals in C </li>
              <li>Operators and Expressions </li>
              <li>Data types </li>
              <li>Input-Output Library Functions </li>
              <li>Control statements </li>
              <li>Function</li>
              <li>Storage class </li>
              <li>Pointer </li>
              <li>Pointer and Function </li>
              <li>Array </li>
              <li>Pointer and array </li>
              <li>Array and function </li>
              <li>Dynamic memory allocation </li>
              <li>String </li>
              <li>String and function </li>
              <li>Command line arguments</li>
              <li>Preprocessor </li>
              <li>Structure </li>
              <li>Structure and function </li>
              <li>File Handling </li>
            </ul>
            
            <h4>
            Syllabus Details
            </h4>
            <ul>
              <li>Introduction to Programming </li>
              <li>Program and Programming </li>
              <li>Programming Languages </li>
              <li>Types of software's </li>
              <li>Operating Systems </li>
              <li>Dos commands </li>
              <li>Basic Linux commands and vi editor </li>
              <li>Compiler, Interpreter, Loader and Linker </li>
            </ul>
            
            <h4>
            Fundamentals in C
            </h4>
            <ul>
              <li>History of 'C' </li>
              <li>A Simple C Program </li>
              <li>Program execution phases </li>
              <li>Backslash character constants </li>
              <li>Character set </li>
              <li>Constants </li>
              <li>Number systems </li>
              <li>Format specifiers </li>
              <li>Identifiers </li>
              <li>Keywords </li>
              <li>Variables </li>
              <li>Data Types </li>
              <li>Declaration of Variable </li>
              <li>Assigning Values to Variables </li>
              <li>Initialization </li>
              <li>Comments </li>
              <li>Const Qualifier </li>
              <li>Basic Structure of a 'C' program </li>
              <li>Programming Examples </li>
            </ul>
            
            <h4>
            Operators and Expressions
            </h4>
            <ul>
              <li>Arithmetic operators </li>
              <li>Increment and decrement operators </li>
              <li>Relational operators </li>
              <li>Logical operators </li>
              <li>The bitwise operators </li>
              <li>The assignment operators </li>
              <li>The size of operator </li>
              <li>The comma operator </li>
              <li>Type casting operator </li>
              <li>Other operators </li>
              <li>Precedence and order of evaluation </li>
              <li>Programming Examples </li>
            </ul>
            
            <h4>
            Data types
            </h4>
            <ul>
              <li>Modifiers </li>
              <li>Format specifiers </li>
              <li>Dealing with each data types </li>
              <li>Memory representation of each type</li>
              <li>Programming Examples </li>
            </ul>
            
            <h4>
            Input-Output Library Functions
            </h4>
            <ul>
              <li> Unformatted I-O Functions </li>
              <li> Single Character Input-Output </li>
              <li>Formatted I-O Functions </li>
            </ul>
            
            <h4>
            Control statements
            </h4>
            <ul>
              <li>Conditional Control Statements </li>
              <li> if-else </li>
              <li>nested if-else </li>
              <li>switch-case </li>
              <li>while </li>
              <li>do-while </li>
              <li>for </li>
            </ul>
            
            <h4>
            Function
            </h4>
            <ul>
              <li>What is function? </li>
              <li>Advantages of using functions </li>
              <li>Function Prototype </li>
              <li>Defining a function </li>
              <li> Calling a function </li>
              <li>Recursion </li>
            </ul>
            
            <h4>
            Pointer
            </h4>
            <ul>
              <li>Def of Pointer </li>
              <li>Declaration of Pointer Variables </li>
              <li>Assigning Address to Pointer </li>
              <li>Pointer to Pointer </li>
            </ul>
            
            <h4>
            Pointer and Function
            </h4>
            <ul>
              <li>Parameter Passing Techniques – call by value, call by address </li>
              <li>Using Pointers as Arguments Function Returning value </li>
              <li>Returning More than one value From A Function</li>
              <li>Calling A function through function pointer </li>
              <li>Passing A function's address as an</li>
              <li>Functions with variable number of arguments </li>
            </ul>
            
            <h4>
            Array
            </h4>
            <ul>
              <li>One dimensional arrays </li>
              <li>Declaration of 1D arrays </li>
              <li>Initialization of 1D arrays </li>
              <li>Accessing element of 1D arrays </li>
              <li>Declaration of 2D arrays </li>
              <li>Initialization of 2D arrays </li>
              <li>Accessing element of 2D arrays</li>
              <li>Reading and displaying elements </li>
            </ul>
            
            <h4>
            Dynamic memory allocation
            </h4>
            <ul>
              <li>malloc() </li>
              <li>calloc() </li>
              <li>realloc() </li>
              <li>free() </li>
              <li>Core dump </li>
              <li>Memory leak </li>
              <li>Dynamic 1D and 2D Arrays </li>
            </ul>
            
            <h4>
            Strings
            </h4>
            <ul>
              <li>strings versus character arrays </li>
              <li>Initializing strings </li>
              <li>Reading string </li>
              <li>Displaying string </li>
              <li>The %s format specifier </li>
              <li>string pointers </li>
              <li>Two-dimensional character arrays or array of string </li>
              <li>array of pointers to strings </li>
            </ul>

            <h4>
            Structure and Function
            </h4>
            <ul>
              <li>Passing structure member to a function </li>
              <li>Passing structure variable to a function </li>
              <li>Passing structure variable address to a function </li>
              <li>Passing array of structure to a function </li>
              <li>Returning a structure variable from function </li>
            </ul>
            <h4>
            Union and Enumeration and typedef
            </h4>
            <ul>
              <li>What are unions? </li>
              <li>Structures versus unions </li>
              <li>Working with unions </li>
              <li>Initialising unions </li>
              <li>Advantages of unions </li>
              <li>enum keyword </li>
              <li>typedef keyword </li>
            </ul>
            <h4>
            File Handling
            </h4>
            <ul>
              <li>Using files in C </li>
              <li>Buffer and streams </li>
              <li>Working with text files and Binary </li>
              <li>Files </li>
              <li>File operations using std. library and system calls </li>
              <li>File management I/O functions </li>
              <li>Random Access Files </li>
              <li>Programming Examples </li>
            </ul>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
